module.exports = __webpack_public_path__ + "static/media/img_stylist_two.9e427528.jpg";